// allow obsidian iframe api to work
if (window.global === undefined) {
    window.global = window;
}
